import React from 'react';
import {
  deletePersonalDeConvenios,
  getPersonalDeConvenios,
  patchPersonalDeConvenios,
  postPersonalDeConvenios,
} from 'api/catalogos/personalDeConvenios';
import { getPuestos } from 'api/configuracion/puestos';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';

const getPersonalDeConveniosList = async (params) => {
  const data = await getPersonalDeConvenios(params);
  return data.map((item) => ({ ...item, puesto: item.puesto?.id ?? item.puesto }));
};

// eslint-disable-next-line react/prop-types
const PersonalDeConvenios = ({ permission }) => (
  <PlainCRUD
    permission={permission}
    get={getPersonalDeConveniosList}
    post={postPersonalDeConvenios}
    patch={patchPersonalDeConvenios}
    title="Personal de Firma"
    withoutState
    tableProps={{ allowDelete: false }}
    initialValues={{ estado_activo: true }}
    fields={[
      defaultFields.nombre,
      {
        name: 'puesto',
        label: 'Puesto',
        labelProp: 'descripcion',
        type: 'select',
        required: true,
        colWidth: 200,
        useCatalog: true,
      },
      {
        name: 'estado_activo',
        label: 'Estado',
        type: 'select',
        required: true,
        trueFalse: ['Activo', 'Inactivo'],
        colWidth: 120,
        render: (val) => (val ? 'Activo' : 'Inactivo'),
      },
    ]}
    catalogs={[
      {
        permission: 'puesto',
        get: getPuestos,
        formItemName: 'puesto',
      },
    ]}
  />
);
export default PersonalDeConvenios;
